export default "__VITE_ASSET__2d4d85d8__"